import { render } from "./Sales.vue?vue&type=template&id=7f1ad207&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./Sales.vue?vue&type=style&index=0&id=7f1ad207&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f1ad207"

export default script